import { ScreenReaderOnly } from '@op/opds.opux';
import React, { useContext, useEffect, useState } from 'react';
import { StateContext } from '../State';
import { useMessageGetter } from '@messageformat/react';

const LanguageChangeNotification = (props) => {
    const messageGetter = useMessageGetter('fp');
    const state = useContext(StateContext);
    const [langStatus, setLangStatus] = useState(null);
    const languageChangedMessage = messageGetter('accessibility.languageNotification');

    useEffect(() => {
        setLangStatus('');
        const timeout = setTimeout(() => {
            setLangStatus(languageChangedMessage);
        }, 50);
        return () => clearTimeout(timeout);
    }, [state.lang, languageChangedMessage]);

    return (
        <ScreenReaderOnly>
            <div tabIndex='-1' aria-live='polite' aria-atomic='true' id='language-status'>
                {langStatus}
            </div>
        </ScreenReaderOnly>
    );
};

export default LanguageChangeNotification;
